// extracted by mini-css-extract-plugin
export default {"proposalsOverviewCard":"ClubProposals_proposalsOverviewCard__GzTDH"};